import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class HelperService {

    /* Método responsável por converter um objeto com propriedades que representam objetos em um objeto somente com propriedade e valor
     *  Ex: De: {nome: 'teste', especie:{id: 1, nome: 'especieDeTeste'}}
     *      Para: { nome: 'teste', especie.id:1, especie.nome: especieDeTeste }
     *
     * Essa função será utilizada para converter objetos em parâmetros de filtros que devem ser passados para api de listar REST (QBE)
     */
    public converterParaObjetoLinear(obj): object
    {
        let objetoLInear = {};
        _.forOwn(obj, (valor, chave) =>
        {
            if (this.ehObjeto(valor))
            {
                //Limitação: Só navega no primeiro nível de profundidade, visto que o BNDES Bdrige só permite também
                //filtrar até o primeiro nível de profundidade
                _.forOwn(valor, (valorObjNivel1, chaveObjNivel1) =>
                {
                    if (!this.ehObjeto(valorObjNivel1))
                    {
                        if (this.possuiValor(valorObjNivel1))
                        {
                            objetoLInear[`${chave}.${chaveObjNivel1}`] = valorObjNivel1;
                        }
                    }
                });
            } else
            {
                if (this.possuiValor(valor))
                {
                    objetoLInear[chave] = valor;
                }
            }
        });
        return objetoLInear;
    }

    public converterArrayParaObjeto(array, campoChave, campoValor): object
    {
        if (!this.ehArrayNuloOuVazio(array))
        {
            return _.mapValues(_.keyBy(array, campoChave), campoValor);
        }
        return {};
    }

    public ehObjeto(obj: any): boolean {
        return typeof obj === 'object'
    }

    public ehIndefinido(obj: any): boolean {
        return obj === null || typeof obj === 'undefined' || obj === 'undefined';
    }

    public ehDefinido(obj: any): boolean {
        return !this.ehIndefinido(obj);
    }

    public ehString(obj: any): boolean {
        return (typeof obj === 'string' || obj instanceof String);
    }

    public ehNumero(obj: any): boolean{
        return !isNaN(obj);
    }

    public possuiValor(obj: any): boolean {
        if (this.ehIndefinido(obj)) {
            return false;
        }
        if (this.ehString(obj)) {
            return obj.trim() !== '';
        }
        return true;
    }

    public ehNuloOuVazio(obj: any): boolean {
        return !this.possuiValor(obj);
    }

    public ehArrayNuloOuVazio(arr: any): boolean {
        if (this.ehIndefinido(arr)) {
            return true;
        }
        return !arr.length || arr.length === 0;
    }

    ehArrayComItens(arr: any): boolean {
        if (this.ehIndefinido(arr)) {
            return false;
        }
        return arr.length && arr.length > 0;
    }

    public extend(): object {
        const newObj: any = {};
        for (let i = 0; i < arguments.length; i++) {
            const obj = arguments[i];
            for (const propriedade in obj) {
                if (propriedade) {
                    newObj[propriedade] = obj[propriedade];
                }
            }
        }
        return newObj;
    }

    public clonar(obj: object): any {
        return JSON.parse(JSON.stringify(obj));
    }

    public clonarEAtribuir(item: object, valores: any): any {
       const itemClonado = this.clonar(item);
       _.assign(itemClonado, valores);
       return itemClonado;
    }

    public atribuir(item: object, valores: any): any {
       _.assign(item, valores);
       return item;
    }

    public extrairSeExistir(object: any, property: string, valorPadrao: any): any
    {
        if (object.hasOwnProperty(property))
        {
          const value = object[property];
          return value;
        }
        return valorPadrao || null;
    }

    public existeAlgumaPropriedadePreenchidaEmProfundidade(obj)
    {
        for (let chave in obj)
        {
            let valor = obj[chave];
            if (_.isPlainObject(valor))
            {
                let resultado = this.existeAlgumaPropriedadePreenchidaEmProfundidade(valor);
                if (resultado)
                {
                    return true;
                }
            } else
            {
                if (!this.ehNuloOuVazio(valor))
                {
                    return true;
                }
            }
        }
        !this.ehNuloOuVazio('saiu aqui');
        return false;
    }
    public mapValuesDeep = (obj, fn) =>
    {
        return _.mapValues(obj, (val, key) =>
        {
            return _.isPlainObject(val)
                    ? this.mapValuesDeep(val, fn)
                    : fn(val, key, obj)
        })
    }

    public compareStringIgnoreCase(a: string, b: string): boolean {
        return a && b && a.trim().toLocaleUpperCase() === b.trim().toLocaleUpperCase();
    }
}
